import {IOverlayParameter} from "@/types/map";
import {loadModules} from "esri-loader";
import TripLineRender from "./TripLineRender";
import WallRendere from "./WallRenderer";

export default class WallLayer {
  private static intances: Map<string, WallLayer>;

  public static getInstance(view: __esri.SceneView) {
    const id = view.container.id;
    if (!WallLayer.intances) {
      WallLayer.intances = new Map();
    }
    let instance = WallLayer.intances.get(id);
    if (!instance) {
      instance = new WallLayer(view);
      WallLayer.intances.set(id, instance);
    }
    return instance;
  }

  private view!: __esri.SceneView;
  private wallRenderer!: WallRendere;
  private TripLineRender!: TripLineRender;
  private initialized = false;

  private constructor(view: __esri.SceneView) {
    this.view = view;
  }

  private async initialize() {
    type MapModules = [
      typeof import("esri/views/3d/externalRenderers"),
      typeof import("esri/geometry/support/webMercatorUtils"),
      typeof import("esri/geometry/SpatialReference")
    ];
    const [
      externalRenderers,
      webMercatorUtils,
      SpatialReference
    ] = await (loadModules([
      "esri/views/3d/externalRenderers",
      "esri/geometry/support/webMercatorUtils",
      "esri/geometry/SpatialReference"
    ]) as Promise<MapModules>);

    this.wallRenderer = new WallRendere(
      this.view,
      externalRenderers,
      webMercatorUtils
    );
    externalRenderers.add(this.view, this.wallRenderer);

    // this.TripLineRender = new TripLineRender(
    //   this.view,
    //   externalRenderers,
    //   webMercatorUtils,
    //   SpatialReference
    // );
    //externalRenderers.add(this.view, this.TripLineRender);

    this.initialized = true;
  }

  public async addWalls(params: IOverlayParameter) {
    if (!this.initialized) {
      await this.initialize();
    }

    this.wallRenderer.updateWallLines(params.overlays);
  }

  public deleteAllWalls() {
    if (this.wallRenderer) {
      this.wallRenderer.deleteAllWallLines();
    }
  }
}
